export default "__VITE_ASSET__CAh7C45P__"